// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  API_PDF: 'http://181.53.253.101:3001/api',
  API_AUTH: 'https://microservicios-test.introsh01.com/auth-service',
  API_AUTHENTICATION: 'https://microservicios-test.introsh01.com/authentication-service',
  API_FILTERS: 'https://microservicios-test.introsh01.com/filters-service',
  API_IMAGENES: 'https://microservicios-test.introsh01.com/guardar-consultar-imagenes',
  API_REPORTES : 'https://microservicios-test.introsh01.com/generar-reportes',
  API_FILTROS: 'https://microservicios-test.introsh01.com/generar-filtros',
  API_HISTORIA: 'https://microservicios-test.introsh01.com/guardar-historia',
  REPORTES_API : 'https://reportes-api.introsh01.com/api'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
